export const DOPPLER_TILE_SOURCE_MODES = Object.freeze({
  direct: 'direct',
  proxy: 'proxy',
});

export function createDirectTileFailureState() {
  return {
    totalTileErrors: 0,
    failedFrames: new Set(),
  };
}

export function registerDirectTileFailure(failureState, frameIndex) {
  failureState.totalTileErrors += 1;
  failureState.failedFrames.add(frameIndex);
  return failureState;
}

export function clearDirectTileFailure(failureState, frameIndex) {
  if (!failureState.failedFrames.has(frameIndex)) {
    return failureState;
  }

  failureState.failedFrames.delete(frameIndex);
  if (failureState.failedFrames.size === 0) {
    failureState.totalTileErrors = 0;
  }

  return failureState;
}

export function shouldFallbackToProxy({
  tileSourceMode,
  proxyFallbackEnabled,
  directFailureFallbackEnabled,
  totalTileErrorCount,
  failedFrameCount,
  tileErrorThreshold,
  frameThreshold,
}) {
  return (
    tileSourceMode === DOPPLER_TILE_SOURCE_MODES.direct &&
    proxyFallbackEnabled &&
    directFailureFallbackEnabled &&
    totalTileErrorCount >= tileErrorThreshold &&
    failedFrameCount >= frameThreshold
  );
}

export function getDirectFailureFallbackReason({ totalTileErrorCount, failedFrameCount }) {
  return `Repeated direct tile failures detected (${totalTileErrorCount} tile errors across ${failedFrameCount} frames).`;
}
